var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-i"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"maintenance-page"},[_vm._m(0),_c('h2',[_vm._v("We will be back soon!")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenanceMessage)}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-logo"},[_c('img',{attrs:{"alt":"","src":"/images/logo.png"}})])
}]

export { render, staticRenderFns }